// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectBrandingRulesMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_PFIX_BRANDING_RULES_RESP);
        this.Tools = null;
        this.CompanyName = null;
        this.CompanyURL = null;
        this.BrokerInformation = null;
        this.PoweredByName = null;
        this.PoweredByURL = null;
        this.BrandingDemoregistrationURLs = Array();
        this.BrandingDemoregistrationURLNames = Array();
        this.BrandingForgotpwdURL = '';
        this.BrandingIpServicesURL = '';
        this.BrandingWebName = '';
        this.BrandingWebLoginBanner = '';
        this.BrandingWebLoginBannerLightTheme = '';
        this.BrandingWebSplashScreen = '';
        this.BrandingWebHeader = '';
        this.BrandingWebHeaderLightTheme = '';
        this.BrandingWebFavicon = '';
        this.BrandingLoginPromptText = '';
        this.BrandingExternalAuthenticationType = '';
        this.BrandingExternalAuthenticationUrl = '';
        this.BrandingExternalAuthenticationWebClientId = '';
        this.BrandingExternalAuthenticationWebMobileClientId = '';
        this.BrandingExternalAuthenticationLogoutUrl = '';
        this.BrandingWMLoginBanner = '';
        this.BrandingWMBackgroundImage = '';
        this.BrandingWMFavicon = '';
        this.BrandingInvestingCustomScheme = '';
        this.BrandingInvestingFavicon = '';
        this.BrandingInvestingSplashScreen = '';
        this.BrandingInvestingLoginBanner = '';
        this.BrandingInvestingWebHeader = '';
        this.BrandingWebLangFiles = '';
        this.BrandingWebCustomUrl = '';
        this.BrandingAllowPasswordPreview = '';
        this.BrandingAllowSavePassword = '';
        this.BrandingTVLogo = '';
        this.BrandingTVFavicon = '';
        this.BrandingTVName = '';
        this.BrandingWebhookURL = '';
        this.BrandingWebhookHelpURL = '';
    }
}
